var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsEditIcon = function SvgDsEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.934 1.991a1.333 1.333 0 0 0-1.868-.017L1.742 9.99a1.33 1.33 0 0 0-.409.96v2.383c0 .737.597 1.334 1.334 1.334h2.057c.353 0 .693-.14.943-.39L14 5.942c.52-.52.52-1.365 0-1.886zM9.065 4.79l1.926-1.855L13.057 5l-1.89 1.89zm-.96.925L2.666 10.95v2.383h2.057l5.5-5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgDsEditIcon;